import script from "./ClassroomStudentApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClassroomStudentApp.vue?vue&type=script&lang=ts&setup=true"

import "./ClassroomStudentApp.vue?vue&type=style&index=0&id=ffbc4e14&lang=scss"

const __exports__ = script;

export default __exports__